export const digitalSpaceFilter = {
  0: 'Sem Espaço Digital',
  1: 'Com Espaço Digital'
};

export const digitalSpaceStatus = {
  0: 'Não',
  1: 'Sim'
};
